import { lazy } from 'react';

const ExpensesPage = lazy(() => import('../pages/Expenses.page'));
const AddExpensePage = lazy(() => import('../pages/AddExpense.page'));

const ExpensesRoutes = [
    {
        path: '/expenses',
        element: <ExpensesPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/expenses/add',
        element: <AddExpensePage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ExpensesRoutes };
